module.exports = __webpack_public_path__ + "static/img/vitigni.1c59235.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/vitigni.png
// module id = r8Un
// module chunks = 1